function loadTestCode() {
    // Observer
    function observerElm(target, callbackFn) {
        var config = {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true,
        };
        var callback = function (mutationsList, observer) {
            callbackFn(mutationsList, observer);
        };
        var observer = new MutationObserver(callback);
        observer.observe(target, config);
    }

    function codeUpdates() {
        // Sticky button
        function isElementOutOfView(el) {
            const rect = el.getBoundingClientRect();
            const headerHeaight = document.querySelector('sticky-header').getBoundingClientRect().height;
            return rect.bottom <= headerHeaight;
        }

        function toggleStickyButton() {
            const firstSection = document.querySelector('#MainContent > section:first-child #openBookClassModalButton');
            const stickyButton = document.querySelector('.footer-sticky');
            if (firstSection && stickyButton) {
                if (isElementOutOfView(firstSection)) {
                    stickyButton.style.display = 'block';
                    document.body.style.paddingBottom = stickyButton.clientHeight + 'px';
                } else {
                    stickyButton.style.display = 'none';
                    document.body.style.paddingBottom = '';
                }
            }
        }

        const stickyButtonwait = setInterval(() => {
            const productReview = (document.querySelector('.es-badge-rating')) ? document.querySelector('.es-badge-rating').outerHTML : '';
            if (productReview) {
                clearInterval(stickyButtonwait);
                if (!document.querySelector('.footer-sticky .product-review .es-badge-rating') && productReview) {
                    document.querySelector('.footer-sticky .product-review').insertAdjacentHTML('beforeend', productReview);
                    document.querySelector('.footer-sticky').style.display = 'block';
                }

                window.addEventListener('scroll', toggleStickyButton);
                window.addEventListener('resize', toggleStickyButton);
                toggleStickyButton();

                var bookeasyPopupBtn = setInterval(() => {
                    const bookeasyBtn = document.querySelector('#openBookClassModalButton');
                    const bookeasyBtnNew = document.querySelector('.footer-sticky .btn-book-now');
                    if (bookeasyBtn && bookeasyBtnNew) {
                        clearInterval(bookeasyPopupBtn)

                        bookeasyBtnNew.addEventListener('click', function () {
                            bookeasyBtn.click();
                        });
                    }
                });
            }
        });
      
        // Cart sidebar Checkout button text changes Checkout to Continue
        var cartButton = setInterval(() => {
            const checkoutButtonSpan = document.querySelector('#rebuy-cart .rebuy-cart__checkout-button > span');
            if (checkoutButtonSpan) {
                clearInterval(cartButton);
                checkoutButtonSpan.childNodes.forEach(node => {
                    if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Checkout')) {
                        node.textContent = node.textContent.replace('Checkout', 'Continue to checkout');
                    }
                });
            }
        });
    }

    codeUpdates();
}

// Check condition and initialize the code
const checkCondition = setInterval(() => {
    if (document.querySelectorAll('body').length > 0) {
        clearInterval(checkCondition);
        loadTestCode();
    }
}, 100);